module.exports = __webpack_public_path__ + "media/solidmap-animation.eea1c891.webm";